import axios from 'axios'

export default {
    get: (eventId) => axios.get(`events/${eventId}/history/whatsapp`),
    getBatchDetail: (eventId, batchId) => axios.get(`events/${eventId}/history/whatsapp/${batchId}/detail`),
    resendFailed: (eventId, batchId) => axios.post(`events/${eventId}/history/whatsapp/${batchId}/resend-failed`),
    downloadExcelDetail: (eventId, batchId) => axios.post(`events/${eventId}/history/whatsapp/${batchId}/download-excel`).then(function (response) {
        if (response.type == "success") {
            window.open(response.data, '_blank');
        } else {
            store.commit('toast', { color: response.type, message: response.message });
        }
    }),
}